(function ($) {
  $(function() {

      var $allVideos = $("iframe[src*='vimeo.com'], iframe[src*='youtube.com'], object, embed");


  	$allVideos.each(function() {
      var url = $(this).attr("src");
      if(/youtube/.exec(url)) {
        var char = url.indexOf("?") != -1 ? "&" : "?";
        $(this).attr("src",url+char+"wmode=transparent");
      }

  	  $(this)
  	    // jQuery .data does not work on object/embed elements
  	    .attr('data-aspectRatio', $(this).height() / $(this).width())
  	    .removeAttr('height')
  	    .removeAttr('width');

  	});

  	$(window).resize(function() {

  	  var newWidth;
  	  $allVideos.each(function() {

        newWidth = $(this).parent().width();

  	    var $el = $(this);
  	    $el
  	        .width(newWidth)
  	        .height(newWidth * $el.attr('data-aspectRatio'));

  	  });

  	}).resize();

  });
})(jQuery);
